import React from 'react';
import {
    TextField,
    NumberField,
    DateField,
    BooleanField,
    ChipField,
    useRecordContext,
    Labeled
} from 'react-admin';
import { Box, Typography, Card, CardContent, Divider } from '@mui/material';
import { useTranslate } from 'react-admin';
import { useMetadataDefinitions } from '../lib/customHooks';

const DynamicMetadataDisplay = ({ entityType }) => {
    const translate = useTranslate();
    const record = useRecordContext();
    const metadataDefinitions = useMetadataDefinitions(entityType);
    const role = localStorage.getItem('role');
    
    // Filter definitions based on view permissions
    const visibleDefinitions = metadataDefinitions.filter(def => {
        return def.charity_can_view || role === 'admin' || role === 'umbrella';
    });
    
    if (!visibleDefinitions || visibleDefinitions.length === 0 || !record?.metadata) {
        return null;
    }
    
    const renderField = (definition) => {
        const fieldName = `metadata.${definition.field_name}`;
        const value = record.metadata[definition.field_name];
        
        if (value === undefined || value === null) {
            return null;
        }
        
        let field;
        switch (definition.field_type) {
            case 'TEXT':
                field = <TextField source={fieldName} />;
                break;
                
            case 'NUMBER':
                field = <NumberField source={fieldName} />;
                break;
                
            case 'DATE':
                field = <DateField source={fieldName} />;
                break;
                
            case 'BOOLEAN':
                field = <BooleanField source={fieldName} />;
                break;
                
            case 'SELECT':
                field = <ChipField source={fieldName} />;
                break;
                
            default:
                field = <TextField source={fieldName} />;
        }
        
        return (
            <Box key={definition.id} sx={{ mb: 2 }}>
                <Labeled label={definition.field_label}>
                    {field}
                </Labeled>
                {definition.field_description && (
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, fontSize: '0.75rem' }}>
                        {definition.field_description}
                    </Typography>
                )}
            </Box>
        );
    };
    
    return (
        <Box mt={3}>
            <Card>
                <CardContent>
                    <Typography variant="h6" gutterBottom>
                        {translate('Additional Information')}
                    </Typography>
                    <Divider sx={{ mb: 2 }} />
                    
                    {visibleDefinitions.map(definition => renderField(definition))}
                </CardContent>
            </Card>
        </Box>
    );
};

export default DynamicMetadataDisplay;